import { render } from "./004-LightShowpage.vue?vue&type=template&id=32a457e0&scoped=true"
import script from "./004-LightShowpage.vue?vue&type=script&lang=js"
export * from "./004-LightShowpage.vue?vue&type=script&lang=js"

import "@/assets/css/news.css?vue&type=style&index=0&id=32a457e0&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a457e0"]])

export default __exports__